import * as ToastPrimitive from '@radix-ui/react-toast'
import { cn } from '@vgw/tailwind-merger'
import { Cross1 } from '@vgw/multibrand-fe-icon'
import { ComponentProps, ReactElement } from 'react'

type ToastCloseProps = ComponentProps<typeof ToastPrimitive.Close> & {
  icon?: ReactElement
}

const ToastClose = ({ className, icon, ...props }: ToastCloseProps) => {
  return (
    <ToastPrimitive.Close {...props} className={cn('size-fit', className)}>
      {icon ?? <Cross1 className="size-4" />}
    </ToastPrimitive.Close>
  )
}

export { ToastClose }
